import badge1ShiftImage from "@src/appV2/lib/assets/images/badge-1-shift.svg";
import badge10ShiftsImage from "@src/appV2/lib/assets/images/badge-10-shifts.svg";
import badge50ShiftsImage from "@src/appV2/lib/assets/images/badge-50-shifts.svg";
import badge100ShiftsImage from "@src/appV2/lib/assets/images/badge-100-shifts.svg";
import badge500ShiftsImage from "@src/appV2/lib/assets/images/badge-500-shifts.svg";
import badge1000ShiftsImage from "@src/appV2/lib/assets/images/badge-1000-shifts.svg";
import badge2000ShiftsImage from "@src/appV2/lib/assets/images/badge-2000-shifts.svg";

// Badge types as const array
export const BADGE_TYPES = [
  "completed-2000-shifts",
  "completed-1000-shifts",
  "completed-500-shifts",
  "completed-100-shifts",
  "completed-50-shifts",
  "completed-10-shifts",
  "completed-1-shift",
] as const;

// Type for badge names
export type BadgeType = (typeof BADGE_TYPES)[number];

export function isBadgeType(value: string): value is BadgeType {
  return BADGE_TYPES.includes(value as BadgeType);
}

// Badge definitions with title, description, and image reference
export const BADGES_DATA: Record<BadgeType, { title: string; description: string; image: string }> =
  {
    "completed-2000-shifts": {
      title: "GOAT Status",
      description:
        "2000 shifts completed! Your dedication to healthcare is truly inspirational. You're making an incredible difference.",
      image: badge2000ShiftsImage,
    },
    "completed-1000-shifts": {
      title: "1k Club",
      description:
        "You've completed 1000 shifts! Your commitment to healthcare excellence has made a tremendous impact.",
      image: badge1000ShiftsImage,
    },
    "completed-500-shifts": {
      title: "500 Club",
      description:
        "500 shifts completed! Your consistent dedication makes you an invaluable healthcare professional.",
      image: badge500ShiftsImage,
    },
    "completed-100-shifts": {
      title: "Century Club",
      description:
        "You've completed 100 shifts! Your consistent dedication makes you an outstanding healthcare professional.",
      image: badge100ShiftsImage,
    },
    "completed-50-shifts": {
      title: "Half-Century Club",
      description:
        "Congratulations on completing 50 shifts! You're becoming a trusted healthcare professional.",
      image: badge50ShiftsImage,
    },
    "completed-10-shifts": {
      title: "Rising Star",
      description:
        "10 shifts completed! You're building a strong foundation and showing great potential.",
      image: badge10ShiftsImage,
    },
    "completed-1-shift": {
      title: "First Step",
      description:
        "Congratulations on completing your first shift! Here's to the beginning of your journey with us.",
      image: badge1ShiftImage,
    },
  };

// Type for accessing badge data
export type BadgeData = (typeof BADGES_DATA)[keyof typeof BADGES_DATA];
